import Vue from "vue";
import { post, fetch, Del, put } from "../../../../ask/axios";
import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue'
import { now } from "moment";
import { downloadFile, fileSteamDownload } from '@/utils/download'

export default {
  components: { menberMenu },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },
      titNames: "Billing",
      titUrls: ",",
      BillStartTime: '',
      BillEndTime: '',
      OrderStartTime: '',
      OrderEndTime: '',
      datetimePlaceholder: 'Select date',
      foldNum: [],//折叠的下标
      isLoading: true,
      BillConvertAmount: null,//账单金额总计
      UnConvertAmount: null, //待支付金额


      IsExpbill: false,
      showModal: false,
      IsShowOrderCreateTime: false,
      IsShowInStoreTime: false,
      ExportType: 'TOTAL',
      Format: 'PDF',
      Orderstatus: null,
      IsTime: false,
      TimeMsg: '',
      //分页
      currentPage: 1,//当前页数
      pageSize: 20, //，每页显示的条数
      total: 0, //查询结果条数
      OrderList: [],
      statusOptions: [
        { value: null, label: "Bill Status" },
        { value: 0, label: "Undeducted" },
        { value: 1, label: "Deducted" },
        { value: 2, label: "Deduction failed" }
      ],
      ProgressWidth: 0,
      //订单号参考号
      OrderNO: '',
      // 开始日期
      pickerBeginDateBefore: {
        disabledDate: this.DateBefore
      },
      //结束日期
      pickerBeginDateAfter: {
        disabledDate: this.DateAfter
      },
      pickerOrderBefore: {
        disabledDate: this.OrderBefore
      },
      //结束日期
      pickerOrderAfter: {
        disabledDate: this.OrderAfter
      },
      ExportBtn: true,
      SumUSD: '',
      SumCNY: '',
      SumHKD: '',
      SumEUR: '',

      SumNotPayUSD: '',
      SumNotPayCNY: '',
      SumNotPayEUR: '',
      SumNotPayHKD: '',
      OrderTime: '',

      RecevedTime: '',
      queryStartTime: '',
      queryEndTime: '',
      queryOrderStartTime: '',
      queryOrderEndTime: '',
    }
  },
  created() {
    this.GetCusAmount();
    this.datetime();
    this.GetBill();
  },
  methods: {
    /*================分页开始==========================*/
    handleSizeChange(val) {
      this.pageSize = val
      this.StatusSelect();
    },
    handleCurrentChange(val) {
      this.foldNum = []
      this.currentPage = val;
      this.StatusSelect();
    },
    TimeIsnull(ballbegintime, ballendtime, orderbegintime, orderendtime) {
      if ((ballbegintime && ballendtime) || (orderbegintime && orderendtime)) {
        this.TimeMsg = ''
        this.IsTime = false;
        return true;
      } else {
        this.TimeMsg = 'Please select the Bill date or the Order date to query.'
        this.IsTime = true;
        return false;
      }

    },
    //时间跨度不能超过3个月
    checkTime() {
      // 双双存在就判断该值是否在三个月之内
      if (this.BillStartTime && this.BillEndTime) {
        let EndTime = new Date(new Date(this.BillStartTime).setMonth(this.BillEndTime.getMonth() - 3))
        let Flag = new Date(this.BillStartTime).getTime() - EndTime
        if (Flag >= 0) {
          return true;
        } else {
          this.TimeMsg = 'The time range cannot exceed 3 months.'
          this.IsTime = true;
          return false;
        }

      } else {
        return true
      }

    },
    fold(index) {
      if (!this.foldNum.length) {
        this.foldNum.push(index)
        $('.foldCss').eq(index).slideDown()
        return
      }
      for (let i = 0; i < this.foldNum.length; i++) {
        if (this.foldNum[i] == index) {
          this.foldNum.splice(i, 1)
          return
        }
      }
      this.foldNum.push(index)
      $('.foldCss').eq(index).slideDown()
    },
    checkTime2() {
      if (this.OrderStartTime && this.OrderEndTime) {

        let EndTime = new Date(new Date(this.OrderStartTime).setMonth(this.OrderEndTime.getMonth() - 3))
        let Flag = new Date(this.OrderStartTime).getTime() - EndTime
        if (Flag >= 0) {
          return true;
        } else {
          this.TimeMsg = 'The time range cannot exceed 3 months.'
          this.IsTime = true;
          return false;
        }
      } else {
        return true
      }
    },

    // 开始赋值
    datetime() {
      this.BillEndTime = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
      let BillStartTime = new Date(new Date().setMonth(this.BillEndTime.getMonth() - 1))
      this.BillStartTime = new Date(new Date(new Date(BillStartTime).toLocaleDateString()).getTime());
    },
    // 状态变更
    StatusSelect() {
      this.GetBill();
    },
    searchBill() {
      this.currentPage = 1
      this.GetBill()
    },
    // 账单
    GetBill() {
      if (!this.TimeIsnull(this.BillStartTime, this.BillEndTime, this.OrderStartTime, this.OrderEndTime)) {
        return false;
      }
      if (this.BillStartTime && this.BillEndTime) {
        let EndTime = new Date(new Date(this.BillEndTime).setMonth(this.BillEndTime.getMonth() - 3))
        let Flag = new Date(this.BillStartTime).getTime() - EndTime + 1 * 60 * 60 * 24 * 1000
        if (Flag < 0) {
          this.TimeMsg = 'The time range cannot exceed 3 months.'
          this.IsTime = true;
          return false
        } else {
          this.TimeMsg = ''
          this.IsTime = false;
        }
      }
      if (this.OrderStartTime && this.OrderEndTime) {
        let EndTime = new Date(new Date(this.OrderEndTime).setMonth(this.OrderEndTime.getMonth() - 3))
        let Flag = new Date(this.OrderStartTime).getTime() - EndTime + 1 * 60 * 60 * 24 * 1000
        if (Flag < 0) {
          this.TimeMsg = 'The time range cannot exceed 3 months.'
          this.IsTime = true;
          return false
        } else {
          this.TimeMsg = ''
          this.IsTime = false;
        }
      }
      let skip = (this.currentPage - 1) * 20
      this.api.param = {
        "OrderNO": this.OrderNO,
        "BillCreateTimeStart": this.BillStartTime ? new Date(this.BillStartTime).Format('yyyy-MM-dd hh:mm:ss') : '',
        "BillCreateTimeEnd": this.BillEndTime ? new Date(this.BillEndTime).Format('yyyy-MM-dd hh:mm:ss') : '',
        "OrderCreateTimeStart": this.OrderStartTime ? new Date(this.OrderStartTime).Format('yyyy-MM-dd hh:mm:ss') : '',
        "OrderCreateTimeEnd": this.OrderEndTime ? new Date(this.OrderEndTime).Format('yyyy-MM-dd hh:mm:ss') : '',
        // "BillStatus": this.Orderstatus,
        "Skip": skip,
        "Take": this.pageSize
      }
      this.isLoading = true
      this.api.url = this.$api03 + '/api/TradeCustomer/Bill/MakingBillQueryEn'
      post(this.api.url, this.api.param).then((res) => {
        if (res.IsOK) {
          this.isLoading = false
          this.queryStartTime = this.BillStartTime
          this.queryEndTime = this.BillEndTime
          this.queryOrderStartTime = this.OrderStartTime
          this.queryOrderEndTime = this.OrderEndTime
          this.OrderList = res.Results.OrderList;
          this.OrderList.forEach((ele, i) => {
            ele.id = i
            this.foldNum.push(i)
          });
          this.SumUSD = res.Results.SumUSD
          this.SumCNY = res.Results.SumCNY
          this.SumHKD = res.Results.SumHKD
          this.SumEUR = res.Results.SumEUR

          this.SumNotPayUSD = res.Results.SumNotPayUSD
          this.SumNotPayCNY = res.Results.SumNotPayCNY
          this.SumNotPayHKD = res.Results.SumNotPayHKD
          this.SumNotPayEUR = res.Results.SumNotPayEUR

          this.total = res.Results.Total;
        } else {
          this.isLoading = false
        }
      })
    },
    getCurrency(Curryency) {
      let CurryCode = ['¥ ', 'US $', 'HK $', '€']
      return CurryCode[Curryency - 1]
    },
    // 处理和显示
    ModeName(code) {
      if (code == '1')
        return 'Express'
      if (code == '3')
        return 'Air Freight'
    },
    typeName(code) {
      if (code == '1')
        return 'Deducted'
      if (code == '2')
        return 'Deduction failed'
      if (code == '0')
        return 'Undeducted'
    },

    // 控制格式时 000  2359
    getTimeStartFromat(CurValue, index) {
      if (new Date(this.BillStartTime).getTime() > new Date(this.BillEndTime).getTime() && this.BillStartTime) {
        this.BillEndTime = ''
      }
      if (new Date(this.OrderStartTime).getTime() > new Date(this.OrderEndTime).getTime() && this.OrderStartTime) {
        this.OrderEndTime = ''
      }
      if (CurValue) {
        if (CurValue.length <= 11) {
          CurValue = `${CurValue} 00:00:00`
          if (index == 1) {
            this.BillStartTime = new Date(CurValue)
          } else {
            this.OrderStartTime = new Date(CurValue)
          }
        }
      }
      //判断是否是长度大于11，不是 就说明是年月日
    },
    getTimeEndFromat(CurValue, index) {
      if (new Date(this.BillEndTime).getTime() < new Date(this.BillStartTime).getTime() && this.BillEndTime) {
        this.BillStartTime = ''
      }
      if (new Date(this.OrderEndTime).getTime() < new Date(this.OrderStartTime).getTime() && this.OrderEndTime) {
        this.OrderStartTime = ''
      }
      if (CurValue) {
        if (CurValue.length <= 11) {
          CurValue = `${CurValue} 23:59:59`
          if (index == 1) {
            this.BillEndTime = new Date(CurValue)
          } else {
            this.OrderEndTime = new Date(CurValue)
          }
        }
      }
    },
    // 限制日期框
    DateBefore(time) {
      return time.getTime() > Date.now()
    },
    DateAfter(time) {
      return time.getTime() > Date.now()
    },
    OrderBefore(time) {
      return time.getTime() > Date.now()
    },
    OrderAfter(time) {
      return time.getTime() > Date.now()
    },

    // 弹框和一些其他
    GetCusAmount() {
      this.api.url = this.$api02 + '/api/EbayCustomer/MyBill/GetCusAmount';
      this.api.param = {
        "QueryType": 2
      }
      post(this.api.url, this.api.param).then((res) => {
        if (res.ErrorCode == 'C0001') {
          this.UnConvertAmount = res.Results.UnConvertAmount;
        }
      })

    },
    Exportorder() {
      this.IsExpbill = true;
      this.showModal = true;
    },
    //关闭弹窗
    GetClose() {
      this.showModal = false;
      this.IsExpbill = false;
    },

    //  --------------导出账单
    ExportorderApi(type = 0, item = '') {
      this.ProgressWidth = 0
      this.ExportBtn = false
      clearInterval(inter)
      let inter = setInterval(() => {
        this.ProgressWidth++
        if (this.ProgressWidth >= 400) {
          this.ProgressWidth = 0
        }
      }, 100);

      // 判断是单个导出，还是全部导出
      const allUrl = '/api/TradeCustomer/Bill/MakingBillExportEn';
      const url = '/api/TradeCustomer/Bill/MakingBillExportEnBySingle';
      this.api.url = this.$api03 + (type == 0 ? allUrl : url);
      this.OrderNO = type == 0 ? this.OrderNO : item;

      // this.api.param = {
      //   OrderNO: this.OrderNO,
      //   ExportType: this.ExportType,
      //   Format: this.Format
      // }


      // this.api.url=this.$api03+'/api/TradeCustomer/Bill/MakingBillExportEn';

      this.api.param = {
        OrderNO: this.OrderNO,
        // OrderNO: item,
        BillCreateTimeStart: this.queryStartTime ? new Date(this.queryStartTime).Format('yyyy-MM-dd hh:mm:ss') : '',
        BillCreateTimeEnd: this.queryEndTime ? new Date(this.queryEndTime).Format('yyyy-MM-dd hh:mm:ss') : '',
        OrderCreateTimeStart: this.queryOrderStartTime ? new Date(this.queryOrderStartTime).Format('yyyy-MM-dd hh:mm:ss') : '',
        OrderCreateTimeEnd: this.queryOrderEndTime ? new Date(this.queryOrderEndTime).Format('yyyy-MM-dd hh:mm:ss') : '',
        IsShowOrderCreateTime: this.IsShowOrderCreateTime,
        IsShowInStoreTime: this.IsShowInStoreTime,
        ExportType: this.ExportType,
        Format: this.Format
      }
      post(this.api.url, this.api.param).then((res) => {
        this.ProgressWidth = 400
        this.ExportBtn = true
        clearInterval(inter)
        if (res.IsOK) {
          let Name = ''
          if (this.Format == 'EXCEL') {
            Name = 'Billing Report_' + new Date().Format('yyyyMMdd') + '.xls'
          } else {
            Name = 'Billing Report_' + new Date().Format('yyyyMMdd') + '.pdf'
          }
          let url = res.Results

          fileSteamDownload(this, {
            FullPath: url, // 路径
            CurrentFileName: Name // 文件名称
          }, Name)
        } else {
          this.$alert('Export failure', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confrim',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            center: true
          }).then(() => {
          }).catch(() => {
          });
        }
      })
    },
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/payment/mybill.js